import React from "react";
import './ProgramTypes.css'
import SingleType from "./SingleType";

function ProgramTypes() {
  return (
    <section className="programmes">

<SingleType/>
<SingleType/>
<SingleType/>
<SingleType/>
<SingleType/>
<SingleType/>

    </section>
  );
}

export default ProgramTypes;
